import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ComProductEmployeeJobModel } from 'src/app/model/com-product-employee-job.model';

@Injectable({
  providedIn: 'root'
})
export class ComProductEmployeeJobService {
  private url:string;

  ////////////////
  constructor(
    private http:HttpClient
  ) {
    this.url=environment.services_url;
  }

  //
  getAll=()=> {
    return this.http.get(`${this.url}/commission-process/list`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getAllBySchema=(schemaId:number)=> {
    return this.http.get(`${this.url}/commission-process/listBySchema/${schemaId}`)
    .pipe(
      map((resp:any)=> resp)
    );
  }
  save=(commission:ComProductEmployeeJobModel)=> {
    return this.http.post(`${this.url}/commission-process/save-commission`, commission)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  saveAll=(commissions:ComProductEmployeeJobModel[])=> {
    return this.http.post(`${this.url}/commission-process/save-all-commission`, commissions)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  update=(commission:ComProductEmployeeJobModel)=> {
    return this.http.post(`${this.url}/commission-process/update-comm-pro/${commission.EmployeeJobId}`, commission)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  checkIfExists=(commissions:ComProductEmployeeJobModel[])=> {
    return this.http.post(`${this.url}/commission-process/validarPromociones`, commissions)
    .pipe(
      map((resp:any)=> resp)
    );
  }
}
